module.exports = __webpack_public_path__ + "static/img/Ed-Richards.1150119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ed-Richards.jpg
// module id = ekZu
// module chunks = 0